/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, {useState} from "react";


import {Col, Form} from "react-bootstrap";
import {AiFillEye, AiFillEyeInvisible, AiOutlineEye} from "react-icons/all";


type FormFieldType = {
    xs?: any;
    lg?: any;
    sm?: any;
    xl?: any;
    fieldValue: string;
    fieldValueHandler(e: React.ChangeEvent<HTMLInputElement>): void;
    fieldControlID?: string,
    fieldType?: "text" | "number" | "password" | "email" | "date";
    fieldLabel?: string | null;
    fieldPlaceholder?: string | null;
    fieldError?: string | null;
    fieldDisabledStatus?: boolean;
    fieldLegend?: string | null;
    cssClasses?: string;
    autoComplete?: string;
    props?: any;
};


export const FormFieldComponent: React.FC<FormFieldType> = ({
    xs = 12, lg= null, sm= null, xl = null,
    fieldValue, fieldValueHandler, fieldControlID = "",
    fieldType = "text",
    fieldLabel = null, fieldPlaceholder = null,
    fieldError = null,
    fieldDisabledStatus = false,
    fieldLegend = null,
    cssClasses = "",
    autoComplete = "off",
    ...props
}): JSX.Element => {


    cssClasses = (cssClasses ? `${cssClasses} ` : "") + "form-field-component";


    const PROPS: any = {};

    if (fieldType === "number") PROPS.min = "0";
    if (fieldType !== "password") PROPS.placeholder = fieldPlaceholder || fieldLabel || "";


    const [inputFieldType, setInputFieldType]= useState<string>(fieldType);
    const [inputFieldShowContentStatus, setInputFieldShowContentStatus]= useState<boolean>(false);

    const changeInputFieldShowContentStatus = () => {
        setInputFieldType(!inputFieldShowContentStatus ? "text" : fieldType);
        setInputFieldShowContentStatus(!inputFieldShowContentStatus);
    };

    return (
        <Col xs={xs} sm={sm || xs} lg={lg || sm || xs} xl={xl || lg || sm || xs} className={cssClasses}>

            <Form.Group controlId={fieldControlID}>

                {!!fieldLabel &&
                <Form.Label>{fieldLabel}:</Form.Label>
                }

                <Form.Control
                    type={inputFieldType}
                    value={fieldValue} onChange={fieldValueHandler}
                    className={(fieldError ? "error" : "")}
                    disabled={fieldDisabledStatus}
                    {...props}
                    {...PROPS}
                    placeholder={""}
                    autoComplete={autoComplete}
                />


                {(fieldType === "password" || inputFieldShowContentStatus) &&
                <span className={"password-field-eye-icon"} onClick={() => changeInputFieldShowContentStatus()}>
                    {inputFieldShowContentStatus ? <AiFillEye /> : <AiFillEyeInvisible />}
                </span>
                }

                {!!fieldError &&
	            <Form.Label className={`error`}>{fieldError}</Form.Label>
                }

                {!!fieldLegend &&
	            <Form.Label className={"legend"}>{fieldLegend}</Form.Label>
                }

            </Form.Group>

        </Col>
    );

};


export default FormFieldComponent;
